import axios from "axios";
import { MessageBox, Message, Loading } from "element-ui";

const service = axios.create({
  // baseURL: "http://8.134.120.63/", // api base_url,
  baseURL: "http://8.134.167.49/", // api base_url,
  timeout: 60 * 1000, // 请求超时时间,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
  crossDomain: true
});

service.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  }
  // 服务器状态码不是200的情况  以下是举例示范，根据具体需求做调整
  // error => {
  //   if (error.response.status) {
  //     switch (error.response.status) {
  //       // 401: 未登录
  //       // 未登录则跳转登录页面，并携带当前页面的路径
  //       // 在登录成功后返回当前页面，这一步需要在登录页操作。
  //       case 401:
  //         // Message({
  //         //   message: msg,
  //         //   type: 'error'
  //         // })
  //         // return Promise.reject(new Error(msg))
  //         notification.error({
  //           message: "请求失败",
  //           description: "登录过期，请重新登录"
  //         });
  //         break;
  //       // 403 token过期
  //       // 登录过期对用户进行提示
  //       // 清除本地token和清空vuex中token对象
  //       // 跳转登录页面
  //       case 403:
  //         notification.error({
  //           message: "请求失败",
  //           description: "登录过期，请重新登录"
  //         });
  //         break;
  //       // 404请求不存在
  //       case 404:
  //         notification.error({
  //           message: "请求失败",
  //           description: "网络请求不存在"
  //         });
  //         break;
  //       // 其他错误，直接抛出错误提示
  //       default:
  //         notification.error({
  //           message: "请求失败",
  //           description: error.response.data.message
  //         });
  //     }
  //     return Promise.reject(error.response);
  //   }
  // }
);

/** 四种不同的请求方式代码
 * get post put delete
 * url  对应的是请求地址
 * params  对应的是请求携带参数
 */

export function get(url, params, showLoading = false) {
  // 空值过滤
  let newObj = {};
  for (let key in params) {
    if (params[key]) {
      newObj[key] = params[key];
    }
  }
  const laoding = Loading.service({
    body: true
    // lock: true
  });
  return new Promise((resolve, reject) => {
    service
      .get(url, { params: newObj })
      .then(res => {
        laoding.close();
        resolve(res.data);
      })
      .catch(err => {
        laoding.close();
        reject(err);
      });
  });
}

export function post(url, params) {
  const laoding = Loading.service({
    body: true
    // lock: true
  });
  return new Promise((resolve, reject) => {
    service
      .post(url, JSON.stringify(params))
      .then(res => {
        laoding.close();
        resolve(res.data);
      })
      .catch(err => {
        laoding.close();
        reject(err);
      });
  });
}

export function del(url, params) {
  return new Promise((resolve, reject) => {
    service
      .delete(url, { params: params })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function put(url, params) {
  return new Promise((resolve, reject) => {
    service
      .put(url, JSON.stringify(params))
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}



// WEBPACK FOOTER //
// ./src/utils/request.js